interface IServerResponseStatus {
  Code: number;
  Message: string;
}

export interface IServerResponse {
  Status: IServerResponseStatus;
  Data: any;
}

export interface IStatusResult {
  Code: HttpStatusCodes;
  Message: string;
}

export enum HttpStatusCodes {
  OK = 200,
  Unauthorized = 401,
  Forbidden = 403,
  InternalServerError = 500,
}

export const GetResponseStatus = (responseObject: IServerResponse): IStatusResult => {
  return {
    Code: responseObject.Status.Code,
    Message: responseObject.Status.Message,
  };
};

export const GetResponseHttpStatus = (responseObject: IServerResponse): HttpStatusCodes => {
  let statusCode = responseObject?.Status?.Code as number;
  let code = statusCode as HttpStatusCodes;
  return code;
};
